import store from "@/store";
import colors from "vuetify/lib/util/colors";

const state = {
  name: "custom",

  dark: {
    primary: "#21CFF3",
    accent: "#FF4081",
    secondary: "#21dc79",
    success: "#4caf50",
    info: "#2196F3",
    warning: "#FB8C00",
    error: "#FF5252",

    background: "#171717",
    background_alt: "#171717",
    background_off: "#1d1d1d",
    footerColor: "#171717",
  },

  light: {
    primary: "#22daff",
    accent: "#ff6b99",
    secondary: "#26ff8c",
    success: "#4caf50",
    info: "#2196F3",
    warning: "#FB8C00",
    error: "#ff5252",

    background: colors.shades.white,
    background_alt: colors.shades.white,
    background_off: "#F4F4F5",
    footerColor: colors.shades.white,
  },
};

const getters = {
  retrieveCustomThemeDetails: (state) => {
    return state;
  },

  retrieveCustomThemePrimary: (state) => {
    return state.light.primary;
  },

  retrieveCustomThemeBackground: (state) => {
    return state.light.background;
  },
};

const actions = {
  setCustomPrimaryColour({ commit }, payload) {
    commit("setCustomPrimaryColour", payload);
  },

  setCustomBackgroundColour({ commit }, payload) {
    commit("setCustomBackgroundColour", payload);
  },
};

const mutations = {
  setCustomPrimaryColour: (state, value, type) => {
    console.log("-- Updated Primary");
    console.log(value);
    console.log(type);

    state.light.primary = value;
    state.dark.primary = value;

    if (store.getters.retrieveCustomTheme) {
      //We Are using a custom theme so get the details and load them
      console.log("-- Apply Custom Theme");
      store.dispatch(
        "setVuetifyTheme",
        store.getters.retrieveCustomThemeDetails
      );
    }

    return;
  },

  setCustomBackgroundColour: (state, value, type) => {
    console.log("-- Updated Background");
    console.log(value);
    console.log(type);

    state.light.background = value;
    state.light.background_alt = value;
    state.light.background_off = "#F4F4F5";
    state.light.footerColor = value;

    state.dark.background = value;
    state.dark.background_alt = value;
    state.dark.background_off = value;
    state.dark.footerColor = value;

    if (store.getters.retrieveCustomTheme) {
      //We Are using a custom theme so get the details and load them
      console.log("-- Apply Custom Theme");
      store.dispatch(
        "setVuetifyTheme",
        store.getters.retrieveCustomThemeDetails
      );
    }

    return;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
